import { DepotFormValues } from '../types'

export function parseDepotFromFormValues(formValues: DepotFormValues): uui.domain.client.rm.Depot {
  const { id, name, location, color, setupCost, setupTime } = formValues

  return {
    id,
    name,
    location,
    color: color.slice(1),
    setupCost: setupCost > 0 ? setupCost * 100 : -1,
    setupTimeSec: setupTime > 0 ? setupTime : -1,
    orderSteps: {},
  }
}
